import { render } from "./Root.vue?vue&type=template&id=272f01b3&scoped=true"
import script from "./Root.js?vue&type=script&lang=js"
export * from "./Root.js?vue&type=script&lang=js"

import "./Root.scss?vue&type=style&index=0&id=272f01b3&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272f01b3"]])

export default __exports__